import {
	RavenInputField,
	RavenModal,
	RavenValidateData,
} from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import {
	capitalizeAllLetter,
	hasDifference,
	reactSelectStyle,
	removeSpace,
} from '../../../../../utils/helper/Helper';
import { areEqual, isTrulyEmpty } from '../../../../../utils/helper/helperTwo';
import { businessCategories } from '../../data/businessCategory';
import { bankboxAPI } from '../../../../../redux/bankbox';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';

interface MyComponentProps {
	onClose?: () => void;
	onPersonalEdit?: () => void;
	visible?: boolean;
	onBusinessEdit?: () => void;
	onFinish?: () => void;
	fromPersonal?: boolean;
	detail: any;
}

const EditUserOptionModal = ({
	onClose,
	onBusinessEdit,
	onPersonalEdit,
	visible,
	fromPersonal,
	detail,
	onFinish,
}: MyComponentProps) => {
	const [step, setStep] = useState(1);
	const stepList = [1, 2];
	const { user_merchant } = useSelector((state: RootState) => state.bankbox);
	const dispatch = useDispatch();
	const [selectedName, setSelectedName] = useState('');
	const [loading, setIsLoading] = useState(false);
	const businessIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
			className="img"
		>
			<path
				stroke={`var(--primary-base-color)`}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
				d="M6.25 9.167H3.833c-.466 0-.7 0-.878.09a.83.83 0 0 0-.364.365c-.091.178-.091.411-.091.878v7m11.25-8.333h2.417c.466 0 .7 0 .878.09.157.08.284.208.364.365.091.178.091.411.091.878v7m-3.75 0V5.167c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H8.917c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757V17.5m12.083 0H1.667m7.5-11.667h1.666M9.167 9.167h1.666M9.167 12.5h1.666"
			></path>
		</svg>
	);

	const personalIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
			className="img"
		>
			<path
				stroke={`var(--primary-base-color)`}
				strokeWidth="1.2"
				d="M2 17.094c0-3.147 2.629-5.697 8-5.697s8 2.55 8 5.697c0 .5-.365.906-.816.906H2.816c-.45 0-.816-.406-.816-.906ZM13 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
			></path>
		</svg>
	);

	const personalTitle = 'Merchant Personal details';

	const optionSelectlist = [
		{
			title: personalTitle,
			text: 'First name, Last name, e.t.c...',
			icon: personalIcon,
		},
		{
			title: 'Merchant Business details',
			text: 'Business name & Business email',
			icon: businessIcon,
		},
	];
	const [formDataStatic, setFormDataStatic] = useState({
		// business_category: {},
		// business_description: '',
		business_name: '',
	});
	const [formData, setFormData] = useState({
		// business_category: {} as any,
		// business_description: '',
		business_name: '',
	});

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		const obj = {
			...formData,
			[name]: name === 'business_name' ? capitalizeAllLetter(value) : value,
		};
		setFormData(obj);
	};

	const handleDisable = () => {
		let val;
		if (step === 1) {
			val = !selectedName;
		}
		if (step === 2) {
			val = RavenValidateData({
				paramOne: formData,
				paramTwo: formDataStatic,
				// checkForEmpty: true,
				// ignoreKeys: ['email'],
			});
		}
		return val;
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		const val = {
			...formData,
			id: String(detail?.id),
			// business_category: formData?.business_category?.value,
		};
		// console.log(val);
		// return;

		const resp = await dispatch(bankboxAPI.updateBusinessMerchant(val as any));

		if (resp.payload?.status === 'success') {
			// setIsLoading(false);
			dispatch(
				bankboxAPI.getSingleUserMerchant({
					email: detail?.poseidon_email as string,
				})
			);
			onFinish && onFinish();
			handleClose();
		} else {
			setIsLoading(false);
		}
	};

	const handleProceed = () => {
		if (step === 1) {
			if (selectedName === personalTitle) {
				onPersonalEdit && onPersonalEdit();
			} else {
				setStep(2);
			}
		}
		if (step === 2) {
			handleSubmit();
		}
	};

	useEffect(() => {
		if (visible && fromPersonal) {
			setStep(2);
			setSelectedName('Merchant Business details');
		}

		if (visible) {
			const request = user_merchant?.business_update;
			const obj = {
				// email: detail?.poseidon_email,
				business_name:
					capitalizeAllLetter(
						removeSpace(
							request?.new_business_name || detail?.poseidon_business_name
						)
					) || '',
				// business_category: {
				// 	label: request?.new_category || detail?.business_category,
				// 	value:
				// 		request?.new_category ||
				// 		detail?.business_category?.toLowerCase()?.replace(/[^a-zA-Z]/g, ''),
				// },
				// business_description:
				// 	request?.new_descriptionn || detail?.poseidon_business_description,
			};
			// console.log(obj);

			setFormData(obj);
			setFormDataStatic(obj);
		}
	}, [visible]);

	const handleClose = () => {
		setSelectedName('');
		setStep(1);
		onClose && onClose();
		setIsLoading(false);
	};

	return (
		<>
			<RavenModal
				onClose={handleClose}
				visble={visible}
				onBtnClick={handleProceed}
				btnColor="deep-green-light"
				btnLabel={step === 1 ? `Proceed` : `Send Change Request`}
				className={`session-expired-wrap-modal`}
				disabled={handleDisable()}
				loading={loading}
				// disabled={formData?.business_name === detail?.poseidon_business_name}
			>
				<div
					// onClick={() => {
					// 	console.log(user_merchant?.business_update);
					// }}
					className="assign-bb-modal edit-user-merchant-detail-modal-wrap-box"
					style={{ paddingBottom: '5rem' }}
				>
					<div className="assign-bb-modal__title">
						<h6>
							{step === 1
								? `What would you like to edit?`
								: `Edit Business details`}
						</h6>
						<p>{`Select merchant profile section you would like to make changes to.`}</p>
					</div>
					{/* grey step box start */}
					<div className="grey-step-wrap-box grey-bg">
						{stepList?.map((chi, idx) => {
							return (
								<div
									key={idx}
									className={`step ${step === chi && 'step-long'} ${
										step >= chi && 'step-active'
									}`}
									onClick={() => {
										if (
											chi === 2 &&
											selectedName &&
											selectedName !== personalTitle
										) {
											setStep(2);
										}
										if (chi === 1) {
											setStep(chi);
										}
									}}
								></div>
							);
						})}
					</div>
					{/* grey step box end */}
					{/* step 1 start =-------- */}
					{step === 1 && (
						<>
							{/* select list box start */}
							<div className="select-list-wrapper-box">
								{optionSelectlist?.map((chi, idx) => {
									return (
										<div
											className={`select-item border-theme ${
												selectedName === chi?.title ? 'select-item-active' : ''
											}`}
											key={idx}
											onClick={() => {
												selectedName === chi?.title
													? setSelectedName('')
													: setSelectedName(chi?.title);
											}}
										>
											<div className="icon-wrap grey-bg">
												<figure className="img-box">{chi?.icon}</figure>
											</div>
											<div className="title-text-box">
												<p className="title">{chi?.title}</p>
												<p className="text grey-white-color">{chi?.text}</p>
											</div>
											{selectedName === chi?.title ? (
												<div className="check-active white-black-bg"></div>
											) : (
												''
											)}
										</div>
									);
								})}
							</div>
							{/* select list box send */}
						</>
					)}
					{/* step 1 end ----------------- */}
					{/* step 2 start */}
					{step === 2 && (
						<>
							<form
								onSubmit={(e) => {
									e.preventDefault();
								}}
								autoComplete="off"
								action=""
								style={{ width: '100%' }}
								className="form-detail-box"
							>
								<RavenInputField
									name="business_name"
									onChange={handleChange}
									value={capitalizeAllLetter(formData.business_name)}
									placeholder="Business Name"
									label="Business Name"
									type="text"
									style={{ zIndex: '4400' }}
									color="deep-green-light"
									// disabled={formData.business_name ? true : false}
								/>
								{/* <RavenInputField
									name="business_category"
									onChange={(e: any) => {
										setFormData({
											...formData,
											business_category: e,
										});
									}}
									selectStyles={reactSelectStyle}
									placeholder="Select a Category"
									label="Business Category"
									value={formData.business_category}
									type="select"
									selectOption={businessCategories}
									style={{ zIndex: '4400' }}
									color="deep-green-light"
								/>
								<RavenInputField
									name="business_description"
									placeholder="Describe your business"
									onChange={handleChange}
									value={formData.business_description}
									label="Business Description"
									type="textarea"
									color="deep-green-light"
								/> */}
							</form>
						</>
					)}
					{/* step 2 end */}
				</div>
			</RavenModal>
		</>
	);
};

export default EditUserOptionModal;
